module.exports = __webpack_public_path__ + "static/illo-killstress-9c84da3e5f4fa3a76f9f967f45c8cd5d.mp4";